module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/yt-bf9663aea16580e485d0b525dfaa73f1.svg";